/**
 * AmbientGlow — two slow-drifting pools of the edge-line colors (indigo and
 * green) behind a hero. Decorative only: absolutely positioned, no pointer
 * events, hidden from assistive tech. Web only; still under reduced motion.
 *
 *   <AmbientGlow />                 // centered behind a hero
 *   <AmbientGlow align="left" />    // pooled toward the left (form pages)
 */
import React from 'react';
import { View } from 'react-native';
import { IS_WEB } from '../../utils/motion';
import injectCss from '../../utils/injectCss';

const CSS = `
[data-ambient-glow] { position: absolute; top: -120px; width: min(1100px, 140vw); height: 620px; pointer-events: none; z-index: 0;
  background: radial-gradient(38% 46% at 34% 42%, rgba(99,102,241,0.22), transparent 70%), radial-gradient(34% 40% at 68% 52%, rgba(52,211,153,0.13), transparent 72%);
  animation: boAmbientGlow 14s ease-in-out infinite alternate; }
[data-ambient-glow="center"] { left: 50%; transform: translateX(-50%); }
[data-ambient-glow="left"] { left: -20%; }
@keyframes boAmbientGlow { from { translate: -2% 0; scale: 1; } to { translate: 2% 0; scale: 1.06; } }
@media (prefers-reduced-motion: reduce) { [data-ambient-glow] { animation: none; } }
`;

export default function AmbientGlow({ align = 'center' }) {
    if (!IS_WEB) return null;
    injectCss('ambient-glow', CSS);
    return <View dataSet={{ ambientGlow: align }} aria-hidden accessibilityElementsHidden importantForAccessibility="no-hide-descendants" />;
}
